export const REQUEST_STARTED = 'add_contacts: fetch_all_request_started';
export const REQUEST_SUCCESS = 'add_contacts: fetch_all_request_success';
export const SET_PARAMS = 'add_contacts: set_params';
export const RESET_STATE = 'add_contacts: reset_state';
export const REPLACE_CONTACT = 'add_contacts: replace_contact';
export const SET_SELECTION_MODEL = 'add_contacts: set_selection_model';
export const RESET_SELECTION_MODEL = 'add_contacts: reset_selection_model';
export const SET_ALL_THAT_MATCH_FILTERS = 'add_contacts: set_all_that_match_filters';
